(() => {
  const forms = '.zubdi-product__form, .zubdi-card__form, .zubdi-cart-recommendation__form';
  let pending = false;

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches(forms) || form.closest('product-form')) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    event.preventDefault();
    if (pending) return;
    const button = event.submitter || form.querySelector('[type="submit"]');
    if (button?.disabled) return;
    pending = true;
    let error = form.querySelector('[data-cart-add-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.cartAddError = '';
      error.setAttribute('role', 'alert');
      form.append(error);
    }
    error.hidden = true;
    form.setAttribute('aria-busy', 'true');
    button?.setAttribute('aria-disabled', 'true');
    try {
      await customElements.whenDefined('cart-drawer');
      drawer.setActiveElement(button || document.activeElement);
      const body = new FormData(form);
      const sections = drawer.getSectionsToRender().map((section) => section.id);
      body.set('sections', sections.join(','));
      body.set('sections_url', window.location.pathname);
      const bundle = form.hasAttribute('data-bundle-form');
      const bundleItems = [...form.querySelectorAll('[data-bundle-variant]')].map(input => ({
        id: Number(input.value), quantity: 1, properties: { Set: form.dataset.bundleTitle }
      }));
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest', ...(bundle ? { 'Content-Type': 'application/json' } : {}) },
        body: bundle ? JSON.stringify({ items: bundleItems, sections, sections_url: window.location.pathname }) : body,
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || window.cartStrings.error);
      if (sections.some((id) => !data.sections?.[id])) {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', sections.join(','));
        const refreshed = await fetch(url);
        if (!refreshed.ok) throw new Error(window.cartStrings.error);
        data.sections = await refreshed.json();
      }
      if (sections.some((id) => !data.sections?.[id])) throw new Error(window.cartStrings.error);
      drawer.renderContents(data);
      if (typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: data, variantId: body.get('id') });
      }
    } catch (failure) {
      error.textContent = failure.message || window.cartStrings.error;
      error.hidden = false;
    } finally {
      pending = false;
      form.removeAttribute('aria-busy');
      button?.removeAttribute('aria-disabled');
    }
  });
})();
